import { path } from 'ramda';

const getGiftCardItems = path(['register', 'giftCards', 'items']);
export const getGiftCards = (state) => {
  const { list, byId } = getGiftCardItems(state);
  return list.map(id => byId[id]);
};

export const getIsLoading = path(['register', 'giftCards', 'isLoading']);

export const getSoldCount = path(['register', 'giftCards', 'summary', 'soldCount']);

export const getOutstandingBalance = path(['register', 'giftCards', 'summary', 'outstandingBalance']);

export const getSoldGiftCards = path(['register', 'giftCards', 'soldGiftCards']);
